module.exports = __webpack_public_path__ + "preapproved_rights.7b29e1570c6fcabbbd3b97d55bb6f213.svg";